import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate } from 'react-router-dom'
import LoadingSpinner from '../../../components/LoadingSpinner'
import { clearAuth, setAuthenticated } from '../../../store/slices/authSlice'
import { useAuth } from '../hooks/useAuth'
import { useFamilyMemberId } from '../hooks/useFamilyMemberId'

const IDENTITY_VERIFIED_KEY = 'familyPortal.identityVerified'

export type AuthGuardProps = {
  children: React.ReactNode
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  const dispatch = useDispatch()
  useFamilyMemberId()

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(setAuthenticated({ isAuthenticated: true }))
    } else if (!isLoading) {
      // Only clear verification flag on actual logout, not during auth rehydration (e.g. refresh)
      sessionStorage.removeItem(IDENTITY_VERIFIED_KEY)
      dispatch(clearAuth())
    }
  }, [isAuthenticated, isLoading, dispatch])

  if (isLoading) {
    return <LoadingSpinner label="Loading…" />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default AuthGuard
